import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'react-bootstrap-icons';
import { useNavigate, useLocation } from 'react-router-dom';

const FAQ = ({ showAll = false, id, layout = 'side' }) => {
    // State to track which question is open (default: first question)
    const [openId, setOpenId] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();

    // All FAQ questions
    const questions = [
        {
            id: 1,
            question: "1. What is FGC-TMS?",
            answer: "FGC-TMS is a cloud-based Trading and Trade Management System built specifically for fixed-income broker dealers, both sell side and buy side firms. It is a full replacement for Legacy Systems, delivering superior customized trading, post-trade automation, real-time reconciliation, and advanced P&L and payout logic at a significantly lower cost. The platform manages the entire trade lifecycle from positions, orders, trading, execution of ingestion through, clearing, settlement, regulatory reporting, and risk and compliance. It provides a single, accurate source of truth for traders, operations, compliance, and management."
        },
        {
            id: 2,
            question: "2. Who is FGC-TMS designed for?",
            answer: "FGC-TMS is designed for small-to-mid-sizedsell side and buy side broker dealers with small to largeapproximately 5–25 trading desksers and moderate-to-high daily trading volumes. It is especially ideal for firms where Legacy System is too expensive, inflexible, or operationally burdensome. These firms typically face profit margin pressure and rely heavily on spreadsheetsbroken and manual processes. FGC-TMS helps them regain efficiency, transparency, and control without enterprise-level costs."
        },
        {
            id: 3,
            question: "3. How is FGC-TMS different from Legacy System?",
            answer: "FGC-TMS is a modern, cloud-native platform built to address the operational gaps left by the Legacy System. While Legacy System is costly, rigid, and heavily dependent on manual processes, FGC-TMS offers real-time reconciliation, automated P&L and payouts, and flexible customization. It is significantly lower in cost and designed to evolve continuously. Most importantly, it reduces operational risk instead of adding to it."
        },
        {
            id: 4,
            question: "4. How much effort is required from our IT team?",
            answer: "Very little to no internal IT effort is required. FGC-TMS is a fully managed SaaS platform with no on-prem infrastructure, upgrades, or maintenance responsibilities for the client. Typically, clients only need to facilitate introductions to ECNs and custodians and assign one operations contact for validation. No dedicated internal IT project or long implementation cycle is needed."
        },
        {
            id: 5,
            question: "5. What is Three-Way Reconciliation?",
            answer: "Three-Way Reconciliation continuously matches what was traded on the ECN, what the custodian shows, and what was reported to regulators such as TRACE. This provides real-time visibility into trade status using clear indicators and immediate identification of breaks or exceptions. It creates a clean audit trail for compliance and significantly reduces end-of-day operational fire drills. Ops teams know exactly where every trade stands at all times."
        },
        {
            id: 6,
            question: "6. Does FGC-TMS support regulatory reporting?",
            answer: "Yes. FGC-TMS supports regulatory workflows including TRACE and MiFID reporting, monitoring and exception management, with clear audit-ready processes. It provides structured documentation and visibility required for regulatory reviews. Best-execution capture is supported through integrations such as BondWave. Native and partner-based reporting options are available depending on regulatory and client requirements."
        },
        {
            id: 7,
            question: "7. Can FGC-TMS really replace Legacy System?",
            answer: "Yes. FGC-TMS is already live as a full Legacy System replacement for multiple clients in the US and UK. It supports all core Legacy System functions, including trade blotters, clearing and settlement workflows, positions and P&L, finance charge allocation, compliance controls, and regulatory reporting. Clients typically run FGC-TMS in parallel with Legacy System before switching fully. This ensures a smooth, validated transition with minimal risk."
        },
        {
            id: 8,
            question: "8. How risky is it to migrate off Legacy System?",
            answer: "Migration risk is significantly reduced with FGC-TMS because it is designed to run in parallel with existing systems. Firms can validate trades, P&L, payouts, and exceptions side by side with Legacy System before making any switch. There is no forced cutover or \"big bang\" migration. Most clients complete the transition comfortably within one to three months, depending on scope."
        },
        {
            id: 9,
            question: "9. Which asset classes are supported?",
            answer: "FGC-TMS supports a broad range of fixed-income products, including corporates, municipals, treasuries, agencies, ABS, MBS, floaters, money markets, and international bonds. The platform includes a robust fixed-income analytics engine that handles complex calculations such as DVO1, spreads, durations, and convexity. This ensures accurate risk, P&L, and position analysis across asset classes."
        },
        {
            id: 10,
            question: "10. Which venues and custodians do you integrate with?",
            answer: "FGC-TMS integrates with all major fixed-income ECNs and ATSs, including Tradeweb, MarketAxess, ICE Bonds, BondPoint, Bonds.com, TMC, Kithio, and TrueMid. It also connects seamlessly with leading custodians and clearers such as Pershing, RBC, Wedbush, and Mirae. New venues or custodians can be onboarded quickly as business needs evolve."
        },
        {
            id: 11,
            question: "11. How does FGC-TMS handle P&L and payouts?",
            answer: "FGC-TMS fully automates daily P&L and monthly payout calculations, eliminating spreadsheet-based workflows. It accurately calculates realized and unrealized P&L, allocates funding and finance charges, applies firm-specific markups, and manages loss of carryovers. Payout-ready reports are typically available by the third business day. Every figure is fully auditable with drill-down visibility to the underlying trades."
        },
        {
            id: 12,
            question: "12. How are finance charges allocated?",
            answer: "FGC-TMS takes complex, firm-level finance and funding charges received from custodians and allocates them accurately down to desks, traders, and individual positions. This removes guesswork and eliminates common payout disputes. The allocation logic is transparent, consistent, and fully auditable. As a result, trust improves across traders, operations, and management."
        },
        {
            id: 13,
            question: "13. What compliance and risk controls are included?",
            answer: "FGC-TMS includes comprehensive, real-time risk and compliance controls designed for fixed-income trading. These include per-trade, daily, and net limits, DVO1-based and sector-based risk controls, IG and HY segmentation, and security aging alerts. A centralized compliance blotter logs all events and actions with a full audit trail. All alerts are configurable and documented."
        },
        {
            id: 14,
            question: "14. Can FGC-TMS be customized to our workflows?",
            answer: "Yes. Customization is a core part of FGC-TMS's design. Screens, reports, limits, and workflows can be tailored to match how your desk actually operates. Each client runs in a dedicated, isolated environment, ensuring changes do not impact others. The platform adapts to your workflow rather than forcing you to adapt to the system."
        },
        {
            id: 15,
            question: "15. How secure is FGC-TMS?",
            answer: "FGC-TMS is built with strong enterprise-grade security controls. It uses role-based access, strict data segregation, client-level environment isolation, and full audit logging. Users only see the data relevant to their role and permissions. The platform is designed to meet the security expectations of regulated financial institutions."
        },
        {
            id: 16,
            question: "16. Where is the system hosted?",
            answer: "FGC-TMS is hosted in secure, cloud-based environments built on AWS infrastructure. The platform is fully managed by Fintech Global, including monitoring, upgrades, patches, and performance management. Clients benefit from a stable, scalable environment without the burden of internal infrastructure. The system remains current without disruption to daily operations."
        },
        {
            id: 17,
            question: "17. Who owns and operates FGC-TMS?",
            answer: "FGC-TMS is built, owned, and operated by Fintech Global, a firm with over 30 years of experience building global trading systems. The team has deep fixed-income domain expertise and operates live production systems in the US and UK. Development, support, onboarding, and operations are all handled in-house. Fintech Global doesn't just sell software—it runs mission-critical trading platforms."
        },
        {
            id: 18,
            question: "18. What kind of support do you provide?",
            answer: "Fintech Global provides dedicated onboarding, ongoing production support, and continuous enhancements. Clients work directly with domain experts who understand fixed-income workflows, not generic call centers. Support is proactive, focused on preventing issues rather than reacting to them. The goal is long-term operational stability and client success."
        },
        {
            id: 19,
            question: "19. How does pricing work?",
            answer: "FGC-TMS is offered as a transparent SaaS subscription, typically priced 50–80% lower than Legacy System. There are no per-user licensing penalties, and no hidden infrastructure or upgrade costs. Pricing depends on scope, integration, and functionality required. The model aligns cost with value and scale."
        },
        {
            id: 20,
            question: "20. Can we start small and expand later?",
            answer: "Yes. Many clients begin with post-trade workflows such as reconciliation, P&L, and compliance. Once validated, they expand into front-office capabilities like RFQ management, quoting, and execution. FGC-TMS is designed for incremental adoption, allowing firms to grow functionality without disruption. This keeps risk low while delivering immediate value."
        },
        {
            id: 21,
            question: "21. Why should we trust a non-Legacy System alternative?",
            answer: "FGC-TMS is already running in live production environments and solving real operational problems today. It is built by industry veterans who understand fixed-income trading deeply. Clients can validate everything in parallel before committing, which removes uncertainty. Trust is built through transparency, results, and operational proof—not brand size alone."
        },
        {
            id: 22,
            question: "22. What is the biggest reason firms switch to FGC-TMS?",
            answer: "Firms switch to FGC-TMS for four core reasons: integrated and customized trading workflows, significant cost savings, operational sanity, and confidence in their numbers. The platform replaces swivel chair trading, manual, error-prone processes with automation and real-time visibility. It turns fixed-income operations from a daily fire drill into a controlled, predictable process. This directly improves profitability and control."
        }
    ];

    // Determine which questions to display
    const displayedQuestions = showAll ? questions : questions.slice(0, 6);

    // Handle "View More" button click
    const handleViewMore = () => {
        navigate('/how-it-works#faq');
    };

    // Scroll to FAQ section when arriving from homepage with hash
    useEffect(() => {
        if (location.hash === '#faq' && showAll) {
            const faqSection = document.getElementById('faq');
            if (faqSection) {
                setTimeout(() => {
                    faqSection.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location.hash, showAll]);

    const toggleQuestion = (questionId) => {
        // If clicking the same question, close it; otherwise open the clicked one
        setOpenId(openId === questionId ? null : questionId);
    };

    return (
        <section
            id={id}
            className="w-full bg-[#090E1B] py-20 px-4 md:px-8 text-white min-h-[800px] flex items-center justify-center"
        >
            <div className={`max-w-[1270px] w-full flex flex-col gap-[50px] ${layout === 'side' ? 'lg:flex-row lg:gap-[26px]' : 'lg:gap-[50px]'}`}>

                {/* Left Box (Title) */}
                <div className={`w-full flex flex-col gap-[20px] ${layout === 'side' ? 'lg:w-[514px]' : 'text-center'}`}>
                    <h2 className="font-oswald font-bold text-[40px] md:text-[52px] leading-none uppercase">
                        FREQUENTLY ASKED QUESTIONS
                    </h2>
                </div>

                {/* Right Box (Accordion) */}
                <div className={`w-full flex flex-col ${layout === 'side' ? 'lg:w-[730px]' : ''}`}>
                    {displayedQuestions.map((item) => {
                        const isOpen = openId === item.id;
                        return (
                            <div key={item.id} className="w-full border-b border-gray-700">
                                {/* Question Header (Clickable) */}
                                <button
                                    onClick={() => toggleQuestion(item.id)}
                                    className="w-full flex justify-between items-center py-5 text-left cursor-pointer hover:opacity-80 transition-opacity"
                                >
                                    <h3 className="font-bold text-[18px] md:text-[20px] font-inter pr-4">
                                        {item.question}
                                    </h3>
                                    <ChevronDown
                                        size={20}
                                        className={`flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                                    />
                                </button>

                                {/* Answer (Collapsible) */}
                                <div
                                    className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] pb-5' : 'max-h-0'}`}
                                >
                                    <p className="font-inter text-gray-400 text-[15px] leading-relaxed">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        );
                    })}

                    {/* View More Button - Only shown when not showing all */}
                    {!showAll && (
                        <button
                            onClick={handleViewMore}
                            className="mt-8 self-start px-10 py-3 bg-transparent border-2 border-white text-white font-inter font-semibold text-[16px] rounded-[58px] hover:bg-white hover:text-[#090E1B] transition-all duration-300"
                        >
                            View More FAQs
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
